import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ClubMemberService, AlertService } from '../../../services';
import { StorageUtil, DocumentUtil } from '../../../store';
import { ClubTeamsService } from '../../../services/club-teams.service';

@Component({
  selector: 'app-add-player',
  templateUrl: './add-player.component.html',
  styleUrls: ['./add-player.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AddPlayerComponent implements OnInit {

  @Input() teamID: number;
  @Input() teams = [];
  @Output() close = new EventEmitter();

  step = 1;
  players = [];
  tempPlayer: any;

  constructor(
    private spinner: Ng4LoadingSpinnerService,
    private cs: ClubMemberService,
    private as: AlertService,
    private ts: ClubTeamsService
  ) { }

  ngOnInit() {
    DocumentUtil.hideScroll();
  }

  onClose() {
    this.close.emit();
    DocumentUtil.showScroll();
  }

  gotoStep(step) {
    this.step = step;
  }

  onNext(data) {
    this.players = data;
    this.step++;
  }

  onSave(player) {
    this.tempPlayer = player;
  }

  addPlayer(player) {
    this.spinner.show();
    this.cs.addClubTeamUser(this.teamID || player.teamID, {
      userID: player.userID || 0,
      firstName: player.firstName,
      lastName: player.lastName,
      middleName: player.middleName,
      email: player.email,
      gender: player.gender,
      dob: player.dob,
      gradYear: player.gradYear,
      positionID: player.positionID,
      addedBy: StorageUtil.userID,
      playerType: player.playerType,
    }).subscribe(
      () => {
        this.spinner.hide();
        this.close.emit(true);
        this.as.success('High Five! You have successfully added your player.');
      },
      () => {
        this.spinner.hide();
        this.as.error('Something went wrong');
      }
    );
  }

  onNotListed() {
    if (this.tempPlayer && this.tempPlayer.email) {
      this.gotoStep(1);
    } else {
      this.addPlayer(this.tempPlayer);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/add-player/add-player.component.ts